import { render, staticRenderFns } from "./channelDetails.vue?vue&type=template&id=34c5a948&scoped=true&"
import script from "./channelDetails.vue?vue&type=script&lang=js&"
export * from "./channelDetails.vue?vue&type=script&lang=js&"
import style0 from "./channelDetails.vue?vue&type=style&index=0&id=34c5a948&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5a948",
  null
  
)

export default component.exports